import React from 'react';
import TextLoader from 'src/components/10-atoms/loaders/TextLoader';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import styleUtils from 'src/utils/styles';
const Loader = ({}) => {
    const [{ theme }] = useTheme();
    return (React.createElement(TextLoader, { mt: theme.spacing.standard.sm, style: styleUtils.pagePadding, height: 24, lines: 5 }));
};
export default Loader;
